export default {
  unknown: 'Paese sconosciuto',
  AF: 'Afghanistan',
  AX: 'Isole Åland',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'Samoa Americane',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antartide',
  AG: 'Antigua e Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaigian',
  BS: 'Bahamas',
  BH: 'Bahrein',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Bielorussia',
  BE: 'Belgio',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia',
  BQ: 'Bonaire, Sint Eustatius e Saba',
  BA: 'Bosnia ed Erzegovina',
  BW: 'Botswana',
  BV: 'Isola Bouvet',
  BR: 'Brasile',
  IO: "Territorio Britannico dell'Oceano Indiano",
  BN: 'Brunei',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  CV: 'Capo Verde',
  KH: 'Cambogia',
  CM: 'Camerun',
  CA: 'Canada',
  KY: 'Isole Cayman',
  CF: 'Repubblica Centrafricana',
  TD: 'Ciad',
  CL: 'Cile',
  CN: 'Cina',
  CX: 'Isola di Natale',
  CC: 'Isole Cocos (Keeling)',
  CO: 'Colombia',
  KM: 'Comore',
  CG: 'Congo',
  CD: 'Repubblica Democratica del Congo',
  CK: 'Isole Cook',
  CR: 'Costa Rica',
  CI: "Costa d'Avorio",
  HR: 'Croazia',
  CU: 'Cuba',
  CW: 'Curaçao',
  CY: 'Cipro',
  CZ: 'Repubblica Ceca',
  DK: 'Danimarca',
  DJ: 'Gibuti',
  DM: 'Dominica',
  DO: 'Repubblica Dominicana',
  EC: 'Ecuador',
  EG: 'Egitto',
  SV: 'El Salvador',
  GQ: 'Guinea Equatoriale',
  ER: 'Eritrea',
  EE: 'Estonia',
  SZ: 'eSwatini',
  ET: 'Etiopia',
  FK: 'Isole Falkland (Malvine)',
  FO: 'Isole Faroe',
  FJ: 'Fiji',
  FI: 'Finlandia',
  FR: 'Francia',
  GF: 'Guyana Francese',
  PF: 'Polinesia Francese',
  TF: 'Terre Australi Francesi',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germania',
  GH: 'Ghana',
  GI: 'Gibilterra',
  GR: 'Grecia',
  GL: 'Groenlandia',
  GD: 'Grenada',
  GP: 'Guadalupa',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Isole Heard e McDonald',
  VA: 'Santa Sede',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Ungheria',
  IS: 'Islanda',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran',
  IQ: 'Iraq',
  IE: 'Irlanda',
  IM: 'Isola di Man',
  IL: 'Israele',
  IT: 'Italia',
  JM: 'Giamaica',
  JP: 'Giappone',
  JE: 'Jersey',
  JO: 'Giordania',
  KZ: 'Kazakistan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KP: 'Corea del Nord',
  KR: 'Corea del Sud',
  KW: 'Kuwait',
  KG: 'Kirghizistan',
  LA: 'Laos',
  LV: 'Lettonia',
  LB: 'Libano',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libia',
  LI: 'Liechtenstein',
  LT: 'Lituania',
  LU: 'Lussemburgo',
  MO: 'Macao',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldive',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Isole Marshall',
  MQ: 'Martinica',
  MR: 'Mauritania',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Messico',
  FM: 'Micronesia',
  MD: 'Moldavia',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Marocco',
  MZ: 'Mozambico',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Paesi Bassi',
  NC: 'Nuova Caledonia',
  NZ: 'Nuova Zelanda',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Isola Norfolk',
  MK: 'Macedonia del Nord',
  MP: 'Isole Marianne Settentrionali',
  NO: 'Norvegia',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Stato di Palestina',
  PA: 'Panama',
  PG: 'Papua Nuova Guinea',
  PY: 'Paraguay',
  PE: 'Perù',
  PH: 'Filippine',
  PN: 'Isole Pitcairn',
  PL: 'Polonia',
  PT: 'Portogallo',
  PR: 'Porto Rico',
  QA: 'Qatar',
  QC: 'Québec',
  RE: 'Réunion',
  RO: 'Romania',
  RU: 'Federazione Russa',
  RW: 'Ruanda',
  BL: 'Saint-Barthélemy',
  SH: "Sant'Elena, Ascensione e Tristan da Cunha",
  KN: 'Saint Kitts e Nevis',
  LC: 'Santa Lucia',
  MF: 'Saint Martin (parte francese)',
  PM: 'Saint Pierre e Miquelon',
  VC: 'Saint Vincent e Grenadine',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tomé e Principe',
  SA: 'Arabia Saudita',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SX: 'Sint Maarten (parte olandese)',
  SK: 'Slovacchia',
  SI: 'Slovenia',
  SB: 'Isole Salomone',
  SO: 'Somalia',
  ZA: 'Sudafrica',
  GS: 'Georgia del Sud e Isole Sandwich Meridionali',
  SS: 'Sudan del Sud',
  ES: 'Spagna',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SJ: 'Svalbard e Jan Mayen',
  SE: 'Svezia',
  CH: 'Svizzera',
  SY: 'Repubblica Araba Siriana',
  TW: 'Taiwan',
  TJ: 'Tagikistan',
  TZ: 'Tanzania',
  TH: 'Tailandia',
  TL: 'Timor Est',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad e Tobago',
  TN: 'Tunisia',
  TR: 'Turchia',
  TM: 'Turkmenistan',
  TC: 'Isole Turks e Caicos',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ucraina',
  AE: 'Emirati Arabi Uniti',
  GB: 'Regno Unito',
  US: "Stati Uniti d'America",
  UM: 'Isole minori esterne degli Stati Uniti',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela',
  VN: 'Vietnam',
  VG: 'Isole Vergini Britanniche',
  VI: 'Isole Vergini Americane',
  WF: 'Wallis e Futuna',
  EH: 'Sahara Occidentale',
  XK: 'Kosovo',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe'
};
